import { Dispatch, ReactNode, SetStateAction, createContext, useContext } from 'react';

type ReferralContextType = {
  isScriptLoaded: boolean;
  isClaimCreditsButtonEnabled: boolean;
  setIsClaimCreditsButtonEnabled: Dispatch<SetStateAction<boolean>>;
};

const ReferralContext = createContext<ReferralContextType | undefined>(undefined);

export const useReferralContext = () => {
  const context = useContext(ReferralContext);

  if (!context) {
    throw new Error('useReferralContext must be used within a ReferralProvider');
  }

  return context;
};

type ReferralProviderPropsT = {
  children: ReactNode;
} & ReferralContextType;

export const ReferralProvider = ({
  children,
  isScriptLoaded,
  isClaimCreditsButtonEnabled,
  setIsClaimCreditsButtonEnabled,
}: ReferralProviderPropsT) => {
  return (
    <ReferralContext.Provider
      value={{
        isScriptLoaded,
        isClaimCreditsButtonEnabled,
        setIsClaimCreditsButtonEnabled,
      }}
    >
      {children}
    </ReferralContext.Provider>
  );
};
